import { DatePicker } from '@components/datePicker/DatePicker';
import { fakeLocalMidnightFromTZMidnight, ShortDateFormat } from '@utils/date';
import { InfoCircle } from '@assets/svgs';
import { CollapsedField } from '@components/quoteDetails/CollapsedField';
import { QFCTypeExecuted } from '@components/quoteDetails/QuoteFieldControl';
import { formatDate } from 'date-fns';

export interface DateFieldProps extends QFCTypeExecuted {
  onBlur: () => void;
  isRequired: boolean;
  isRequiredBeforeBind?: boolean;
}

const validDate = (v: any) => {
  const date = new Date(v);
  if (date?.toString() !== 'Invalid Date') {
    return fakeLocalMidnightFromTZMidnight(date);
  }
  return new Date(date);
};

export const DateField = ({
  setValue,
  attributeType,
  errorMessage,
  value,
  isCollapsed,
  externalIcon,
  isRequired,
  isRequiredBeforeBind,
  hoverText,
  isReadOnly,
  onBlur,
  ruleEngine,
  isOverriding,
}: DateFieldProps) => {
  if (isCollapsed) {
    const dateValue = value ? validDate(value as string) : null;
    return (
      <CollapsedField
        label={attributeType.label}
        value={
          dateValue && dateValue.toString() !== 'Invalid Date' ? formatDate(dateValue, ShortDateFormat) : undefined
        }
        deprecated={attributeType.deprecated}
      />
    );
  }

  // or DateTime
  // TODO: Validate value instead of casting as string
  const valueRangeRule =
    isOverriding && attributeType.overrideValueRange ? attributeType.overrideValueRange : attributeType.valueRange;
  const [minDate, maxDate] = (ruleEngine.execute(valueRangeRule) ?? []) as [string?, string?];

  return (
    <DatePicker
      fullWidth
      value={value ? validDate(value as string) : null}
      onChange={setValue}
      minDate={
        minDate && minDate?.toString() !== 'Invalid Date'
          ? fakeLocalMidnightFromTZMidnight(new Date(minDate))
          : undefined
      }
      maxDate={
        maxDate && maxDate?.toString() !== 'Invalid Date'
          ? fakeLocalMidnightFromTZMidnight(new Date(maxDate))
          : undefined
      }
      disabled={isReadOnly}
      textFieldProps={{
        inputLabel: attributeType.label,
        inputLabelIcon: hoverText ? <InfoCircle style={{ flexShrink: 0 }} /> : null,
        tooltipTitle: hoverText,
        required: isRequired,
        requiredBeforeBind: isRequiredBeforeBind,
        onBlur,
        helperLabel: errorMessage ?? attributeType?.helpText ?? ' ',
        error: !!errorMessage,
        externalIcon,
        deprecated: attributeType.deprecated,
      }}
    />
  );
};
